import { createContext } from "react";

const ModelosContext = createContext();

export default ModelosContext;
